import { BarChart3, Contact, Filter, Gauge, Megaphone, Users, type LucideIcon } from 'lucide-react';
import type { Permission } from '@crm/shared/permissions';
import type { DashboardCatalog } from '@crm/shared/i18n';

export interface NavItem {
  to: string;
  key: 'overview' | 'funnel' | 'team' | 'clients' | 'marketing' | 'status';
  permission: Permission;
  icon: LucideIcon;
}

/** Pages in menu order. A role sees only the pages its permission allows (docs/SECURITY.md). */
export const NAV_ITEMS: readonly NavItem[] = [
  { to: '/', key: 'overview', permission: 'dashboard.overview', icon: Gauge },
  { to: '/funnel', key: 'funnel', permission: 'dashboard.funnel', icon: Filter },
  { to: '/team', key: 'team', permission: 'dashboard.team', icon: Users },
  { to: '/clients', key: 'clients', permission: 'customers.view_names', icon: Contact },
  { to: '/marketing', key: 'marketing', permission: 'dashboard.marketing', icon: Megaphone },
  { to: '/status', key: 'status', permission: 'data_quality.view', icon: BarChart3 },
];

export const navLabel = (t: DashboardCatalog, item: NavItem): string => t.nav[item.key];
